import React, { useContext, useState } from "react";
import { AppContext } from "../AppContext";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const NotificationPanel = () => {
  const { notification,sendClickStatus } = useContext(AppContext);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* 🔔 Bell Icon */}
      <div
        className="position-fixed  m-3 z-50 notii"
        onClick={() => setIsOpen(true)}
        style={{ cursor: "pointer", zIndex:"9"}}
      >
        <i className="fs-3">🔔</i>
        {notification.length > 0 && (
          <span className="badge bg-danger position-absolute top-0 start-100 translate-middle rounded-pill">
            {notification.length}
          </span>
        )}
      </div>

      {/* 📩 Notification Panel */}
      {isOpen && (
        <div className="notification-panel shadow">
          <div className="d-flex justify-content-between align-items-center border-bottom px-3 py-2 mb-2">
            <h6 className="mb-0 fw-bold ">NOTIFICATIONS</h6>
            <button
              className="btn-close"
              onClick={() => setIsOpen(false)}
              aria-label="Close"
            >
              x
            </button>
          </div>

          <div className="notification-list">
            {notification.map((item) => (
              <Link to={`/news-details/${item.ID}`}  onClick={() => {
                                      sendClickStatus(item.ID, "click");
                                    }}>
                <div
                  key={item.id}
                  className="notification-item d-flex mb-2 p-2 rounded bg-light "
                >
                  <img
                    src={`https://hondaapi.clientcoding.com/${item.guid}`}
                    alt="thumb"
                    className="me-2 rounded"
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "cover",
                    }}
                  />
                  <div className="flex-grow-1 ml-2">
                    <div className="text-truncate-2 fw-medium small">
                      {item.post_title}
                    </div>
                    <div className="text-muted small">
                      {item.post_date_gmt &&
                        new Date(item.post_date_gmt).toLocaleString("en-IN", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                          hour: "numeric",
                          minute: "2-digit",
                          hour12: true,
                        })}
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default NotificationPanel;
